// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font{font-family:"Roboto Condensed","Arial Narrow","Helvetica Neue Condensed",Arial,sans-serif;font-size:16px;line-height:30px;height:30px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
